import { z } from 'zod';

export const organizationMembershipSchema = z.object({
  userId: z.string(),
  organizationId: z.string(),
  grcRole: z.string(),
  admin: z.boolean(),
  subscriptionType: z.string(),
  emailNotificationsEnabled: z.boolean(),
});
export type UserOrganizationEntity = z.infer<
  typeof organizationMembershipSchema
>;
export type UserOrganization = Omit<
  UserOrganizationEntity,
  'userId' | 'organizationId'
>;
export type UserOrganizationMetadata = {
  userId: string;
  organizationId: string;
  isDeleted: boolean;
  eventTime: Date;
};
